import * as BookmarkTypes from 'common/types/reports/bookmark';
import {ShowClause} from 'iron/common/report/insights/util/types';
import {isFormulaShowClause} from 'iron/common/report/insights/models/utils';

export function isSaveableBehavior(behavior: BookmarkTypes.Behavior) {
  return (
    behavior.type === BookmarkTypes.MetricType.Funnel ||
    behavior.type === BookmarkTypes.MetricType.Simple ||
    behavior.type === BookmarkTypes.MetricType.Retention
  );
}

export function hasSaveableBehavior(clause: ShowClause | null) {
  if (!clause || isFormulaShowClause(clause) || !clause.behavior) {
    return false;
  }

  return isSaveableBehavior(clause.behavior);
}
